<app-preloader *ngIf="!treeData" [loaderText]="'Loading Data..'" class="w-100 position-fixed preloader-backdrop">
</app-preloader>
<div class="tree tree--details">
  <div class="card">
    <div [attr.aria-labelledby]="'accordionA-'+i+level" *ngFor="let item of treeData;let i = index;">
      <div class="card-body p-0">
        <section id="accordionA-{{i}}{{level}}">
          <section class="card">
            <div class="card-header"
              [ngClass]="(item.id===selectedNodeId?'activated':'') || (item.item_id===selectedNodeId?'activated':'')"
              id="{{i}}{{level}}" [style.padding-left]="calculatePadding(level)">

              <!-- Parent Node START -->
              <div *ngIf="item.children.length>0" class="row tree--view__header">
                <div class="col" [ngClass]="viewLocation==='project_auth'?'col-10':'col'">

                  <!-- when item.id-->
                  <a *ngIf="item.is_document===1 && viewLocation==='taxonomydetail'" class="float-left parent-node"
                    role="button" data-toggle="collapse" [attr.aria-expanded]="false"
                    data-target="#{{item.id}}-{{level}}" href="#{{item.id}}-{{level}}"
                    [attr.aria-controls]="item.id+'-'+level" id="{{ item.id }}-atag" aria-label="Toggle Node"></a>
                  <a *ngIf="item.is_document!==1 || (viewLocation!=='taxonomydetail')" class="float-left" role="button"
                    data-toggle="collapse" [attr.aria-expanded]="false" data-target="#{{item.id}}-{{level}}"
                    href="#{{item.id}}-{{level}}" [attr.aria-controls]="item.id+'-'+level" id="{{ item.id }}-atag"
                    aria-label="Toggle Node"></a>
                  <div class="card-link" *ngIf="item.id">
                    <div class="list-inline-item">
                      <h2 class="mb-0 font-bold node-text">
                        <a *ngIf="!item.isOrphanLabel" href="javascript:void(0)" id="{{item.id}}-{{'node'}}"
                          (click)="onNodeSelected(item)">
                          {{item.human_coding_scheme}}
                          <span>{{item.full_statement | slice:0:100}}</span>
                          <small style="color:rgb(226, 134, 47)"
                            *ngIf="viewLocation==='pacing_guide_authoring' && item.item_usage_count>0"> USED
                            {{item.item_usage_count}}
                            <span *ngIf="item.item_usage_count===1"> TIME </span><span *ngIf="item.item_usage_count>1">
                              TIMES</span></small>
                        </a>
                        <span *ngIf="item.isOrphanLabel">
                          {{item.human_coding_scheme}}{{item.full_statement}}
                        </span>
                      </h2>
                    </div>
                  </div>
                  <!-- END item.id -->
                  <!-- when item.item_id-->
                  <a class="card-link" role="button" data-toggle="collapse" *ngIf="item.item_id"
                    data-target="#{{item.item_id}}-{{level}}" href="#{{item.item_id}}-{{level}}"
                    [attr.aria-expanded]="false" [attr.aria-controls]="item.item_id+'-'+level">
                    <div class="list-inline-item">
                      <h2 class="mb-0 font-bold node-text">
                        <a *ngIf="!item.isOrphanLabel" href="javascript:void(0)" (click)="onNodeSelected(item)">
                          {{item.human_coding_scheme}}
                          <span>{{item.full_statement | slice:0:100}}</span>
                          <small style="color:rgb(226, 134, 47)"
                            *ngIf="viewLocation==='pacing_guide_authoring' && item.item_usage_count>0"> USED
                            {{item.item_usage_count}}
                            <span *ngIf="item.item_usage_count===1"> TIME </span><span *ngIf="item.item_usage_count>1">
                              TIMES</span></small>
                        </a>
                        <span *ngIf="item.isOrphanLabel">
                          {{item.human_coding_scheme}}{{item.full_statement}}
                        </span>
                      </h2>
                    </div>
                  </a>
                  <!-- END item.item_id-->

                </div>

                <div class="col-auto text-right micro-data">
                  <ul class="list-inline " *ngIf="viewLocation!=='frontfacing'">
                    <li class="list-inline-item node-edit">
                      <button class="btn btn-icon tooltip lg top position-relative d-inline-block" data-tooltip="Edit Node" [attr.aria-label]="'Edit Node'">
                        <em class="material-icons-outlined font-4x" aria-hidden="true">edit</em>
                      </button>
                    </li>
                    <li class="list-inline-item node-add">
                      <button class="btn btn-icon tooltip lg top position-relative d-inline-block" data-tooltip="Add Node" [attr.aria-label]="'Add Node'" (click)="addNode(item)">
                        <em class="material-icons-outlined font-4x" aria-hidden="true">add</em>
                      </button>
                    </li>
                    <li class="list-inline-item node-del">
                      <button class="btn btn-icon tooltip lg top position-relative d-inline-block" data-tooltip="Delete Node" [attr.aria-label]="'Delete Node'" (click)="deleteNode(item)">
                        <em class="material-icons-outlined font-4x" aria-hidden="true">delete</em>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- Parent Node END -->
              <!-- Leaf Node START-->
              <div *ngIf="item.children.length==0" class="card-body card-body--last">

                <div class="row">
                  <div [ngClass]="treeType==='treeview'?'col-md-8':viewLocation==='project_auth'?'col-10':'col-md-12'">

                    <div class="list-inline-item">
                      <h3 class="mb-0 font-bold node-text" *ngIf="item.human_coding_scheme || item.full_statement">
                        <a *ngIf="!item.isOrphanLabel" href="javascript:void(0)"
                          (click)="onNodeSelected(item)">{{item.human_coding_scheme}}
                          {{item.full_statement | slice:0:100}}
                          <small style="color:rgb(226, 134, 47)"
                            *ngIf="viewLocation==='pacing_guide_authoring' && item.item_usage_count>0"> USED
                            {{item.item_usage_count}}
                            <span *ngIf="item.item_usage_count===1"> TIME </span><span *ngIf="item.item_usage_count>1">
                              TIMES</span></small>
                        </a>
                        <span *ngIf="item.isOrphanLabel">
                          {{item.human_coding_scheme}}{{item.full_statement}}
                        </span>
                      </h3>
                    </div>

                  </div>

                  <div class="text-right micro-data" [ngClass]="treeType==='treeview'?'col-md-4':'col-auto'">
                    <ul class="list-inline " *ngIf="viewLocation!=='frontfacing'">
                      <li class="list-inline-item node-edit">
                        <em class="material-icons-outlined font-4x" aria-hidden="true">edit</em>
                      </li>
                      <li class="list-inline-item node-add cursor-pointer" (click)="addNode(item)">
                        <em class="material-icons-outlined font-4x" aria-hidden="true">plus</em>
                      </li>
                      <li class="list-inline-item node-del cursor-pointer" (click)="deleteNode(item)">
                        <em class="material-icons-outlined font-4x" aria-hidden="true">delete</em>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- Leaf Node END -->
            </div>

            <!-- START   -->
            <div *ngIf="item.children.length>0" id="{{item.id}}-{{level}}" class="collapse"
              [attr.aria-labelledby]="item.id+'-'+level" [attr.data-parent]="'#'+item.id+'-'+level">
              <app-tree-accordian [treeData]="item.children" [level]="level+1" [selectedNodeId]="selectedNodeId"
                [viewLocation]="viewLocation" [treeType]="treeType"></app-tree-accordian>
            </div>
            <div *ngIf="item.children.length==0" id="{{item.id}}-{{level}}" class="collapse"
              [attr.aria-labelledby]="item.id+'-'+level" [attr.data-parent]="'#'+item.id+'-'+level">
              <div class="card-body card-body--last">

                <div class="row">
                  <div [ngClass]="treeType==='treeview'?'col-md-8':'col-md-12'">

                    <div class="list-inline-item">
                      <h4 class="mb-0 node-text" *ngIf="item.human_coding_scheme || item.full_statement">
                        <a href="javascript:void(0)" (click)="onNodeSelected(item)"
                          class="col-12">{{item.human_coding_scheme}}
                          {{item.full_statement | slice:0:100}}
                          <small style="color:rgb(226, 134, 47)"
                            *ngIf="viewLocation==='pacing_guide_authoring' && item.item_usage_count>0"> USED
                            {{item.item_usage_count}}
                            <span *ngIf="item.item_usage_count===1"> TIME </span><span *ngIf="item.item_usage_count>1">
                              TIMES</span></small>
                        </a>
                      </h4>
                    </div>

                  </div>

                  <div class="col-auto text-right micro-data" [ngClass]="treeType==='treeview'?'col-md-8':'col-md-12'">
                    <ul class="list-inline" *ngIf="viewLocation!=='frontfacing'">
                      <li class="list-inline-item node-edit">
                        <em class="material-icons-outlined font-4x" aria-hidden="true">edit</em>
                      </li>
                      <li class="list-inline-item node-add">
                        <a href="javascript:void(0);" aria-label="Add node" (click)="addNode(item)">
                          <em class="material-icons-outlined font-4x" aria-hidden="true">add</em>
                        </a>
                      </li>
                      <li class="list-inline-item node-del">
                        <a href="javascript:void(0);" aria-label="delete node" (click)="deleteNode(item)">
                          <em class="material-icons-outlined font-4x" aria-hidden="true">delete</em>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- end of card body -->

            </div>
            <!-- END -->
          </section>
        </section>
      </div>
      <!-- end of card body -->
    </div>
  </div>
</div>
